module.exports = "<table class=\"table table-sm table-hover\">\n  <thead>\n    <tr>\n      <th>Route Name</th>\n      <th>Url</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat=\"route in ctrl.routes\">\n      <td>{{::route.name}}</td>\n      <td><a href=\"{{::route.url}}\" target=\"blank\">{{::route.url}}</a></td>\n    </tr>\n  </tbody>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/testRoutes/testRoutes.html
// module id = 665
// module chunks = 0